import { defineMessages } from 'react-intl';

export default defineMessages({
  searchPlaceholder: {
    id: 'view.search.newui.placeholder',
    defaultMessage: 'Search',
  },
  noResults: {
    id: 'view.filesPage.searchResult.noResultsTitle',
    defaultMessage: 'No results for your search',
  },
  noResultsDescription: {
    id: 'view.filesPage.searchResult.noResultsDescription',
    defaultMessage: 'Try a different search term',
  },
  clearSearch: {
    id: 'view.appBar.search.clear',
    defaultMessage: 'Clear search',
  },
});
